<!-- 设备管理-设备列表页面 -->
<template>
  <div class="vcnDeviceList">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left tree-line-style">
        <div class="left_title">设备信息</div>
        <div class="device-tab">
          <div
            v-for="item in calType.column"
            :key="item.typeId"
            :class="['tab', type.prop == item.prop ? 'active' : '']"
            @click="handleChange(item)"
          >
            {{ item.label }}
          </div>
        </div>
        <!-- <ioc-tab-group :option="calType" @change="handleChange"></ioc-tab-group> -->
        <div v-if="type.prop === 'tab1'" class="left-type_area">
          <ele-group-tree
            @getCode="getDeviceWrokGroupCode"
            @sendData="getDeviceTreeData"
            :deviceType="checkDevType"
            :paramsType="paramsType"
            @refresh="initGet()"
          ></ele-group-tree>
        </div>
        <div v-show="type.prop === 'tab2'" class="left-type_area sbar">
          <div class="device-search">
            <el-input
              placeholder="请输入搜索关键字"
              prefix-icon="el-icon-search"
              v-model="searchString"
              clearable
            >
            </el-input>
          </div>
          <el-scrollbar class="flex-auto" style="height: calc(100% - 50px)">
            <el-tree
              ref="tree"
              class="mb20"
              node-key="areaDevGroupCode"
              :data="areaTreeData"
              :highlight-current="true"
              :default-expand-all="true"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick"
            >
              <template slot-scope="{ node }">
                <element-tree-line
                  :node="node"
                  :showLabelLine="true"
                  :indent="16"
                  class="tree-line"
                >
                  <span class="custom-tree-node" style="display: block">
                    <i class="el-icon-document"></i>
                    <span
                      class="node-label"
                      style="margin-left: 3px"
                      :title="node.label"
                      >{{ node.label }}</span
                    >
                  </span>
                </element-tree-line>
              </template>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>

      <!-- 右侧表单 -->
      <div class="section-mian_right">
        <!-- 头部按钮 -->
        <div class="section-mian__toolbar flex-row">
          <el-button
            type="primary"
            class="iss-operation-button"
            icon="iconfont icon-iconfontfanhui"
            @click="retBtn"
            >{{ $t("cameraList.button.back") }}</el-button
          >
          <!-- <el-button
            v-if="accType && checkDevType === '18'"
            v-auth="'/cameralist/devicelist:update'"
            type="primary"
            class="iss-operation-button"
            icon="iconfont icon-xiugai"
            @click="batchModif"
            >{{ $t("cameraList.button.moreModify") }}</el-button
          > -->
          <el-button
            v-auth="'/cameralist/devicelist:export'"
            type="primary"
            class="iss-operation-button"
            icon="iconfont icon-daochu"
            @click="exportDocument"
            >{{ $t("cameraList.button.export") }}</el-button
          >
          <el-upload
            ref="upload"
            class="upload-demo"
            v-if="accType"
            v-auth="'/cameralist/devicelist:import'"
            multiple
            :limit="1"
            :auto-upload="false"
            :on-change="importDocument"
            action
            :show-file-list="false"
          >
          </el-upload>
          <el-button
            type="primary"
            v-auth="'/cameralist/devicelist:move'"
            class="iss-operation-button"
            icon="iconfont icon-jinru"
            @click="moveIn"
            >{{ $t("cameraList.button.moveInto") }}</el-button
          >
        </div>
        <!-- 搜索框部分 -->

        <div class="section-main__filter" v-if="false">
          <!-- 按照设备划分 -->
          <el-row>
            <!-- <el-form
              v-if="devTypeSer"
              label-width="70px"
              label-position="left"
              :inline="true"
              size="small"
              class="demo-form-inline"
            >
              <el-col :span="5">
                <el-form-item :label="$t('cameraList.label.deviceName')">
                  <el-input
                    v-model="devTyName"
                    clearable
                    :placeholder="$t('cameraList.label.deviceName')"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item
                  v-show="checkDevType === '18'"
                  :label="$t('cameraList.label.camerGet')"
                >
                  <el-select
                    v-model="cameraFeature"
                    :placeholder="$t('cameraList.placeholder.please')"
                  >
                    <el-option
                      v-for="item in cameraFeatureList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item :label="$t('cameraList.label.deviceStatus')">
                  <el-select
                    v-model="cameraStatus"
                    :placeholder="$t('cameraList.placeholder.please')"
                  >
                    <el-option
                      v-for="item in cameraStatusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item :label="$t('cameraList.label.deviceId')">
                  <el-input
                    v-model="devTyId"
                    clearable
                    :placeholder="$t('cameraList.label.deviceId')"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="queryDevList">{{
                  $t("cameraList.button.search")
                }}</el-button>
                <el-button type="info" @click="emptyData">{{
                  $t("cameraList.button.reset")
                }}</el-button>
              </el-col>
            </el-form> -->

            <!-- 按照区域划分 -->
            <!-- <el-form
              v-if="devAreaSer"
              label-width="70px"
              label-position="left"
              :inline="true"
              size="small"
              class="demo-form-inline"
            >
              <el-col :span="5">
                <el-form-item :label="$t('cameraList.label.deviceName')">
                  <el-input
                    v-model="devAreaName"
                    clearable
                    :placeholder="$t('cameraList.label.deviceName')"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item
                  v-show="checkDevType === '18'"
                  :label="$t('cameraList.label.camerGet')"
                >
                  <el-select
                    v-model="cameraFeature"
                    :placeholder="$t('cameraList.placeholder.please')"
                  >
                    <el-option
                      v-for="item in cameraFeatureList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item :label="$t('cameraList.label.deviceStatus')">
                  <el-select
                    v-model="cameraStatus"
                    :placeholder="$t('cameraList.placeholder.please')"
                  >
                    <el-option
                      v-for="item in cameraStatusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item :label="$t('cameraList.label.factory')">
                  <el-select
                    v-model="devAreaManu"
                    :placeholder="$t('cameraList.placeholder.please')"
                  >
                    <el-option
                      v-for="item in serManOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="seaByArea">{{
                  $t("cameraList.button.search")
                }}</el-button>
                <el-button type="info" @click="emptyAreaData">{{
                  $t("cameraList.button.reset")
                }}</el-button>
              </el-col>
            </el-form> -->
          </el-row>
          <!-- <template v-if="devAreaSer">
            <el-checkbox v-model="checked" @change="checkedState">{{
              $t("cameraList.label.areaSet")
            }}</el-checkbox>
          </template>
          <template v-if="devTypeSer">
            <el-checkbox v-model="checkedDevice" @change="checkedDeviceState"
              >仅显示无设备组设备</el-checkbox
            >
          </template>
          <template>
            <el-checkbox v-model="isMap" @change="checkedMapState"
              >仅显示无经纬度设备</el-checkbox
            >
          </template> -->
        </div>
        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table
            ref="devTab"
            :data="tableData"
            :option="calMetOption"
            :page="page"
            @current-change="selectPage"
            @selection-change="selectionChange"
            @size-change="changeSize"
            @search-change="seaByArea"
            @search-reset="emptyAreaData"
          >
            <template slot="search_check">
              <el-checkbox v-model="checked" v-if="devAreaSer" @change="checkedState">{{
                $t("cameraList.label.areaSet")
              }}</el-checkbox>
              <el-checkbox v-model="isMap" v-if="devTypeSer" @change="checkedMapState"
                >无经纬度设备</el-checkbox
              >
              <template v-if="devTypeSer">
                <el-checkbox v-model="checkedDevice" @change="checkedDeviceState"
                  >无设备组设备</el-checkbox
                >
              </template>
            </template>
            <!-- 定制虚拟属性 -->
            <!-- <template slot="cameraFeatureName" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                popper-class="tooltip-draw"
              >
                <div slot="content">{{ scope.row.cameraFeatureName }}</div>
                <span>
                  {{ scope.row.cameraFeatureName | ellipsis(4) }}
                </span>
              </el-tooltip>
            </template> -->
            <!-- 定制操作栏按钮 -->
            <template slot="operate" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="视频配置"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  v-if="scope.row.deviceType == 45"
                  type="text"
                  icon="el-icon-video-camera-solid"
                  @click="videoConfig(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                v-auth="'/cameralist/devicelist:update'"
                :content="$t('cameraList.label.modify')"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-xiugai"
                  @click="modDel(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('cameraList.label.viewDetail')"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  class="el-icon-document"
                  @click="seeDel(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </ioc-table>
        </div>
      </div>
    </div>
    <!-- 查看设备详情弹框 -->
    <appPanel
      :width="700"
      class="app-panel"
      :isExpand="devInfoDialog"
      @cancel="devInfoDialog = false"
      :title="$t('cameraList.label.devDetail')"
    >
      <!-- <el-dialog
      v-ops:width="1180"
      :title="$t('cameraList.label.devDetail')"
      v-dialogDrag
      :close-on-click-modal="true"
      :visible.sync="devInfoDialog"
    > -->
      <view-det ref="viewDet"></view-det>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="devInfoDialog = false">{{
          $t("cameraList.button.close")
        }}</el-button>
      </span>
      <!-- </el-dialog> -->
    </appPanel>
    <!-- 修改设备数据弹框  -->
    <appPanel
      :width="700"
      class="app-panel"
      :isExpand="editDevDialog"
      @cancel="editDlgCan"
      :title="$t('cameraList.label.editDevice')"
    >
      <!-- <el-dialog
      :title="$t('cameraList.label.editDevice')"
      :close-on-click-modal="false"
      v-dialogDrag
      :visible.sync="editDevDialog"
      width="60%"
      @opened="editDevDialogOpen"
    > -->
      <edit-dev ref="editDev"></edit-dev>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDlgCan" :loading="editLoading">{{
          editLoading ? "保存中..." : $t("cameraList.button.cancel")
        }}</el-button>
        <el-button type="primary" @click="editDlgPre" :loading="editLoading">{{
          editLoading ? "保存中..." : $t("cameraList.button.save")
        }}</el-button>
      </span>

      <!-- </el-dialog> -->
    </appPanel>

    <!-- 批量修改弹窗 -->
    <el-dialog
      :title="$t('cameraList.button.moreModify')"
      width="700px"
      :visible.sync="batchModifShow"
    >
      <span>
        <ioc-form v-model="batchModifForm" :option="batchModifOption"></ioc-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchModifNo" type="info">{{
          $t("cameraList.button.cancel")
        }}</el-button>
        <el-button type="primary" @click="batchModifYes">{{
          $t("cameraList.button.conform")
        }}</el-button>
      </span>
    </el-dialog>

    <!--选择设备树-->
    <el-dialog
      width="450px"
      v-dialogDrag
      :title="type.prop === 'tab1' ? '选择挪入设备组' : '选择挪入区域'"
      :visible.sync="deviceTreeShow"
    >
      <el-scrollbar class="dialog-bar" style="height: 400px">
        <div class="dialog-tree">
          <el-tree
            :data="deviceTreeData"
            v-show="type.prop === 'tab1'"
            :highlight-current="true"
            :props="deviceDefaultProps"
            @node-click="selectDeviceNode"
          ></el-tree>
          <el-tree
            :data="areaTreeData"
            v-show="type.prop === 'tab2'"
            :highlight-current="true"
            :props="defaultProps"
            @node-click="selectAreaNode"
          ></el-tree>
        </div>
      </el-scrollbar>

      <span slot="footer" class="dialog-footer">
        <el-button @click="deviceTreeShow = false" type="info">{{
          $t("cameraList.button.cancel")
        }}</el-button>
        <el-button type="primary" @click="moveInDevice">{{
          $t("cameraList.button.conform")
        }}</el-button>
      </span>
    </el-dialog>
    <video-config ref="videoConfig"></video-config>
  </div>
</template>
<script>
import videoConfig from "../components/videoConfig";
import ElementTreeLine from "element-tree-line";
import editDev from "./editDevDlg";
import ViewDet from "./ViewDet";
import { api } from "../api";
import utils from "@src/common/utils";
import { Dic, Cache } from "$utils";
import { deviceTableOption } from "../const/deviceTable";
import appPanel from "@src/components/business/app-panel/index.vue";
import eleGroupTree from "../components/equipmentGroupTree";
export default {
  components: {
    editDev,
    ViewDet,
    eleGroupTree,
    appPanel,
    ElementTreeLine,
    videoConfig,
  },
  watch: {
    searchString(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    return {
      searchString: "",
      editLoading: false,
      clickSearch: false,
      selectedAreaNode: "",
      currentRow: {},
      isIndoorList: {
        是: "1",
        否: "0",
        Yes: "1",
        No: "0",
      },
      batchModifForm: {},
      // 批量修改表单配置项
      batchModifOption: {
        labelWidth: 150,
        menuBtn: false,
        column: [
          {
            label: this.$t("cameraList.label.camerGet"),
            prop: "cameraFicType",
            span: 24,
            type: "radio",
            dicData: Dic.find("SENU014"),
            valueDefault: 0,
            change: ({ value, column }) => {
              console.log(value, column);
            },
          },
        ],
      },
      //摄像机虚拟属性列表
      cameraFeatureList: [],
      // 摄像机状态枚举值
      cameraStatusList: [
        {
          label: this.$t("cameraList.label.Offline"),
          value: 0,
        },
        {
          label: this.$t("cameraList.label.Online"),
          value: 1,
        },
      ],
      //摄像机虚拟属性
      cameraFeature: "",
      // 摄像机状态
      cameraStatus: "",
      delConfirm: false,
      batchModifShow: false,
      deviceTreeShow: false,
      // 提示框内容
      tipData: "",
      // 选中的设备ID
      selDev: [],
      selThirdDev: [],
      selectedDevs: [],
      devInfoDialog: false,
      editDevDialog: false,
      // 选中左侧列表选项的下标
      activeState: Number,
      // 设备类型划分查询条件
      devTyName: "",
      devTyId: "",
      changeAttr: false,
      // 区域划分查询条件
      devAreaManu: "",
      devAreaName: "",
      // 控制仅显示无区域设备
      checked: false,
      checkedDevice: false,
      isMap: false,
      // 按照区域划分时搜索条件设备类型绑定对象
      serDevTyOption: [],
      // 按照区域划分时搜索条件厂家绑定对象
      serManOption: [],
      // 控制头部功能按钮显隐
      accType: true,
      accReg: false,
      // 控制头部搜索条件变更
      devTypeSer: true,
      devAreaSer: false,
      //摄像机分类方式
      type: {},
      calType: {
        column: [
          {
            label: this.$t("cameraList.label.deviceSet"),
            prop: "tab1",
          },
          {
            label: this.$t("cameraList.label.areaSets"),
            prop: "tab2",
          },
        ],
      },
      // 区域树对象
      areaTreeData: [],
      // 设备组树对象
      deviceTreeData: [],
      defaultProps: {
        children: "areaChildren",
        label: "areaDevGroupName",
      },
      deviceDefaultProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
      calMetOption: deviceTableOption(true, false),
      tableData: [],
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      // 请求设备列表的数据对象
      getDevPra: {},
      // 判断是否勾选查询无区域
      isArea: "",
      // 判断是否勾选查询无设备组
      isDeviceWorkGroup: "",
      areaDevGroupCode: "",
      selectedDeviceNode: "",
      // 左侧列表设备类型选中值
      checkDevType: "",
      deviceWorkGroupCode: "",
      paramsType: "",
    };
  },
  created() {
    // 请求全量数据
    this.initGet();
    this.setCheckDevType();
    this.getAreaTree();
    this.getSerManData();
    // 默认进入页面选中第一种分类方式
    if (this.checkDevType === "18") {
      this.calType = {
        column: [
          {
            label: this.$t("cameraList.label.deviceSet"),
            prop: "tab1",
          },
          {
            label: this.$t("cameraList.label.areaSets"),
            prop: "tab2",
          },
        ],
      };
    } else if (this.checkDevType === "26") {
      // 广播
      this.calType = {
        column: [
          {
            label: this.$t("cameraList.label.deviceSet"),
            prop: "tab1",
          },
          {
            label: this.$t("cameraList.label.areaSets"),
            prop: "tab2",
          },
        ],
      };
    } else {
      this.calType = {
        column: [
          {
            label: this.$t("cameraList.label.areaSets"),
            prop: "tab2",
          },
        ],
      };
      this.handleChange({
        label: this.$t("cameraList.label.areaSets"),
        prop: "tab2",
      });
    }
    this.type = this.calType.column[0];
    this.getCameraFeatureList();
  },
  mounted() {},
  destroyed() {
    Cache.remove("deviceTypeName");
    Cache.remove("deviceTypeId");
  },
  methods: {
    videoConfig(row) {
      this.$refs.videoConfig.open(row.deviceId);
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.areaDevGroupName.indexOf(value) !== -1;
    },
    // 批量修改
    batchModif() {
      if (this.selDev.length === 0) {
        this.$message({
          message: this.$t("cameraList.message.confirmSuc"),
          type: "warning",
        });
      } else {
        // 过滤所选摄像机的虚拟属性并去重
        let cameraFeature = Array.from(
          new Set(this.selectedDevs.map((item) => item.cameraFeature))
        );
        // 如果数组长度大于1,即所选摄像机中有不同的虚拟属性,默认为普通摄像机
        if (cameraFeature.length > 1 || cameraFeature[0] === "0") {
          this.batchModifForm.cameraFicType = 0;
        } else if (cameraFeature[0] === "1") {
          this.batchModifForm.cameraFicType = 1;
        } else if (cameraFeature[0] === "2") {
          this.batchModifForm.cameraFicType = 2;
        }
        this.batchModifShow = true;
      }
    },
    //获取摄像机虚拟属性
    getCameraFeatureList() {
      this.cameraFeatureList = Dic.find("SENU014");
    },
    //挪入
    moveIn() {
      if (this.selDev.length <= 0) {
        this.$message({
          message: this.$t("cameraList.message.chooseEnter"),
          type: "warning",
        });
        return;
      }
      this.slectedAreaNode = "";
      this.deviceTreeShow = true;
      this.getAreaTree();
    },
    //挪出
    moveOut() {
      if (this.selDev.length <= 0) {
        this.$message({
          message: this.$t("cameraList.message.chooseOut"),
          type: "warning",
        });
        return;
      }
      if (this.type.prop === "tab1") {
        this.$confirm(
          this.$t("cameraList.message.etherMove"),
          this.$t("cameraList.message.moveOut"),
          {
            confirmButtonText: this.$t("cameraList.button.conform"),
            cancelButtonText: this.$t("cameraList.button.cancel"),
            type: "warning",
          }
        )
          .then(() => {
            let params = {
              operateType: 2,
              deviceIdList: this.selDev,
            };
            this.$fetch(api.updateDeviceDeviceWorkGroup, params).then((response) => {
              if (response.success) {
                this.$message({
                  message: this.$t("cameraList.message.moveSucc"),
                  type: "success",
                });
                // 刷新列表数据
                this.getDevList();
                this.$refs.devTab.selectClear();
              } else {
                this.$message({
                  message: response.msgContent,
                  type: "warning",
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "success",
              message: this.$t("cameraList.message.cancelMove"),
            });
          });
      } else {
        this.$confirm(
          this.$t("cameraList.message.etherMove"),
          this.$t("cameraList.message.moveOut"),
          {
            confirmButtonText: this.$t("cameraList.button.conform"),
            cancelButtonText: this.$t("cameraList.button.cancel"),
            type: "warning",
          }
        )
          .then(() => {
            let params = {
              deviceIds: this.selDev,
            };
            this.$fetch(api.deviceMan.updateDeviceArea, params).then((response) => {
              if (response.success) {
                this.$message({
                  message: this.$t("cameraList.message.moveSucc"),
                  type: "success",
                });
                // 刷新列表数据
                this.getDevList();
                this.$refs.devTab.selectClear();
              } else {
                this.$message({
                  message: response.msgContent,
                  type: "warning",
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "success",
              message: this.$t("cameraList.message.cancelMove"),
            });
          });
      }
    },
    //导出
    exportDocument() {
      // if (this.selDev.length <= 0) {
      //   this.$message({
      //     message: this.$t('cameraList.message.checkOuter'),
      //     type: 'warning'
      //   })
      //   return;
      // }
      let params = {
        cameraFeature: this.cameraFeature,
        isArea: this.checked === true ? "1" : "",
        area: this.areaDevGroupCode, //区域相关的
        isDeviceWorkGroup: this.isDeviceWorkGroup,
        deviceWorkGroupCode: this.deviceWorkGroupCode, //设备组相关的
        deviceId: "",
        deviceName: this.devAreaName,
        deviceType: this.checkDevType,
        factoryId: this.devAreaManu,
        status: this.cameraStatus,
        isMap: this.isMap ? "1" : "",
      };
      this.$fetchDownLoad(api.deviceMan.getDeviceExportList, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        const content = response.data;
        const blob = new Blob([content], { type: "application/vnd.ms-excel" });
        const fileName = this.$t("cameraList.label.listFormat");
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    //导入
    importDocument(file) {
      if (
        file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length) !==
          "xlsx" &&
        file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length) !== "xls"
      ) {
        this.$message({
          message: this.$t("cameraList.message.fileError"),
          type: "warning",
        });
      } else {
        let formData = new FormData();
        formData.append("file", file.raw);
        this.$fetch(api.deviceMan.deviceImportList, formData).then((response) => {
          if (response.success) {
            this.$message({
              message: this.$t("cameraList.message.importSucc"),
              type: "success",
            });
            this.queryDevList();
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
            });
          }
          this.$refs.upload.clearFiles();
        });
      }
    },
    // 请求设备列表
    getDevList() {
      this.tableData = [];
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.deviceMan.getDeviceListByPage, this.getDevPra).then((res) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (res.success) {
          this.calMetOption = deviceTableOption(this.type.prop === "tab1");
          this.$refs.devTab.selectClear();
          this.tableData = res.returnObj.list;
          this.page.total = res.returnObj.total;
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
          });
        }
      });
    },
    //显示无区域设备选中事件
    checkedState() {
      this.page.currentPage = 1;
      this.areaDevGroupCode = "";
      if (this.checked === true) {
        this.isArea = "1";
      } else {
        this.isArea = "";
      }
      let params = {
        isArea: this.isArea,
        area: this.areaDevGroupCode, //区域相关的
        deviceId: "",
        deviceName: this.devAreaName,
        deviceType: this.checkDevType,
        factoryId: this.devAreaManu,
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        parentCodes: "", //区域相关的，父级code
        status: "",
        isMap: this.isMap ? "1" : "",
      };
      this.getDevPra = params;
      this.getDevList();
      // this.getAreaTree();
    },
    //显示无设备组设备选中事件
    checkedDeviceState() {
      this.page.currentPage = 1;
      this.deviceWorkGroupCode = "";
      if (this.checkedDevice === true) {
        this.isDeviceWorkGroup = "1";
      } else {
        this.isDeviceWorkGroup = "";
      }
      let params = {
        isDeviceWorkGroup: this.isDeviceWorkGroup,
        deviceWorkGroupCode: this.deviceWorkGroupCode, //设备组相关的
        deviceId: "",
        deviceName: this.devAreaName,
        deviceType: this.checkDevType,
        factoryId: this.devAreaManu,
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        status: "",
        isMap: this.isMap ? "1" : "",
      };
      this.getDevPra = params;
      this.getDevList();
    },
    checkedMapState() {
      this.page.currentPage = 1;
      this.getDevPra = {
        isMap: this.isMap ? "1" : "",
        isDeviceWorkGroup: this.isDeviceWorkGroup,
        deviceWorkGroupCode: this.deviceWorkGroupCode, //设备组相关的
        deviceId: this.devTyId,
        deviceName: this.devAreaName,
        deviceType: this.checkDevType,
        factoryId: this.devAreaManu,
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        status: this.cameraStatus,
      };
      this.getDevList();
    },
    // 区域树——根据搜索条件搜索设备列表
    seaByArea(param) {
      this.clickSearch = true;
      this.page.currentPage = 1;
      let params = {
        isArea: this.checked === true ? "1" : "",
        area: this.areaDevGroupCode, //区域相关的
        deviceId: "",
        cameraFeature: this.cameraFeature,
        deviceName: this.devAreaName,
        deviceType: this.checkDevType,
        factoryId: this.devAreaManu,
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        parentCodes: "", //区域相关的，父级code
        status: this.cameraStatus,
        isMap: this.isMap ? "1" : "",
        isDeviceWorkGroup: this.isDeviceWorkGroup,
        ...param,
      };
      this.getDevPra = params;
      this.getDevList();
    },
    // 查询厂家信息
    getSerManData() {
      let params = {
        deviceMark: this.checkDevType,
      };
      this.serManOption = [];
      this.$fetch(api.deviceMan.getFactoryListByPage, params).then((res) => {
        res.returnObj.forEach((item) => {
          let data = {};
          data.label = item.factoryName;
          data.value = item.factoryId;
          this.serManOption.push(data);
        });
      });
    },
    getAreaTree() {
      this.$fetch(api.deviceMan.queryAssociationalDeviceTree).then((res) => {
        this.areaTreeData = res.returnObj;
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.areaTreeData[0]);
        });
      });
    },
    getDeviceTreeData(data) {
      this.deviceTreeData = data;
    },
    // 设备类型查询按钮查询设备列表
    queryDevList() {
      this.page.currentPage = 1;
      let params = {
        deviceId: this.devTyId,
        deviceName: this.devTyName,
        deviceType: this.checkDevType,
        cameraFeature: this.cameraFeature,
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        status: this.cameraStatus,
        isDeviceWorkGroup: this.isDeviceWorkGroup,
        deviceWorkGroupCode:
          this.deviceWorkGroupCode !== "" ? this.deviceWorkGroupCode : "",
        isMap: this.isMap ? "1" : "",
      };
      this.getDevPra = params;
      this.getDevList();
    },
    // 设备类型重置搜索框内容
    emptyData() {
      this.cameraFeature = "";
      this.cameraStatus = "";
      this.devTyName = "";
      this.devTyId = "";
      this.isDeviceWorkGroup = "";
      this.checkedDevice = false;
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.queryDevList();
    },
    // 区域重置搜索框内容
    emptyAreaData() {
      this.devAreaName = "";
      this.devAreaManu = "";
      this.cameraFeature = "";
      this.cameraStatus = "";
      this.checked = false;
      this.clickSearch = false;
      this.isArea = "";
      this.isMap = "";
      this.checkedDevice = "";
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      let params = {
        isArea: this.isArea,
        // area:'', //区域相关的
        // 修改3503问题单
        area: this.areaDevGroupCode,
        deviceId: "",
        cameraFeature: "",
        deviceName: "",
        deviceType: this.checkDevType,
        factoryId: "",
        page: 1,
        pageSize: 10,
        parentCodes: "", //区域相关的，父级code
        status: "",
        isMap: this.isMap ? "1" : "",
      };
      this.getDevPra = params;
      this.getDevList();
    },
    // 确认修改
    batchModifYes() {
      this.batchModifShow = false;
      let params = {
        cameraFeature: this.batchModifForm.cameraFicType,
        cameraList: this.selThirdDev,
      };
      this.$fetch(api.deviceMan.updateCameraFeature, params).then((res) => {
        if (res.success === true) {
          this.$message.success(this.$t("cameraList.message.modifySucc"));
        } else {
          this.$message.error(res.msgContent);
        }
        this.$refs.devTab.selectClear();
        this.queryDevList();
      });
    },
    // 取消修改
    batchModifNo() {
      this.batchModifShow = false;
    },
    editDevDialogOpen() {
      this.$refs.editDev.clearValidate();
      this.$refs.editDev.devInData = {
        ...this.currentRow,
        isIndoor: Number(this.currentRow.isIndoor),
      };
      this.$nextTick(() => {
        // 门禁设备时不显示MAC\IP\虚拟属性/端口/账号/密码
        if (this.checkDevType === "2") {
          this.$refs.editDev.devInOption.column[17].display = false;
          this.$refs.editDev.devInOption.column[18].display = false;
          this.$refs.editDev.devInOption.column[19].display = false;
          this.$refs.editDev.devInOption.column[20].display = false;
          this.$refs.editDev.devInOption.column[21].display = false;
          this.$refs.editDev.devInOption.column[22].display = false;
        }
      });
    },
    // 修改设备详情
    modDel(row) {
      this.editDevDialog = true;
      this.currentRow = row;
      this.editDevDialogOpen();
    },
    // 查看详情按钮
    seeDel(row) {
      this.devInfoDialog = true;
      this.$nextTick(() => {
        this.$refs.viewDet.devInData = row;
        this.$refs.viewDet.deviceId = row.deviceId;
        let params = {
          deviceId: row.deviceId,
        };
        this.$fetch(api.deviceMan.getDeviceInfoDetailsById, params).then((res) => {
          this.$refs.viewDet.tabList = res.returnObj;
        });
      });
    },

    // 选择左侧设备类型查询设备列表
    cheDevTy() {
      this.page.currentPage = 1;
      let params = {
        area: "", //区域相关的
        deviceId: this.devTyId,
        deviceName: this.devTyName,
        deviceType: this.checkDevType,
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        parentCodes: "", //区域相关的，父级code
        // status: ''
        status: this.cameraStatus,
        isMap: this.isMap ? "1" : "",
      };
      this.getDevPra = params;
      this.getDevList();
      //  this.activeState = index;
    },
    moveInDevice() {
      if (this.type.prop === "tab1") {
        if (this.selectedDeviceNode === "") {
          this.$message.warning("请选择挪入的设备组");
          return;
        }
        let params = {
          operateType: 1,
          deviceWorkGroupCode: this.selectedDeviceNode,
          deviceIdList: this.selDev,
        };
        this.$fetch(api.updateDeviceDeviceWorkGroup, params).then((response) => {
          if (response.success) {
            this.$message({
              message: this.$t("cameraList.message.moveIntoSucc"),
              type: "success",
            });
            this.deviceTreeShow = false;
            // 刷新界面数据
            this.getDevList();
            this.$refs.devTab.selectClear();
          } else {
            this.$message({
              message: response.msgContent,
              type: "warning",
            });
          }
        });
      } else {
        if (this.selectedAreaNode === "") {
          this.$message.warning(this.$t("cameraList.message.chooseEnterArea"));
          return;
        }
        let params = {
          area: this.selectedAreaNode,
          deviceIds: this.selDev,
        };
        this.$fetch(api.deviceMan.updateDeviceArea, params).then((response) => {
          if (response.success) {
            this.$message({
              message: this.$t("cameraList.message.moveIntoSucc"),
              type: "success",
            });
            this.deviceTreeShow = false;
            // 刷新界面数据
            this.getDevList();
            this.$refs.devTab.selectClear();
          } else {
            this.$message({
              message: response.msgContent,
              type: "warning",
            });
          }
        });
      }
    },
    selectAreaNode(data) {
      this.selectedAreaNode = data.areaDevGroupCode;
    },
    selectDeviceNode(data) {
      this.selectedDeviceNode = data.id;
    },
    // 树节点点击事件
    handleNodeClick(data) {
      this.page.currentPage = 1;
      this.areaDevGroupCode = data.areaDevGroupCode;
      this.isArea = "";
      this.checked = false;
      let params = {
        isArea: this.isArea,
        area: this.areaDevGroupCode, //区域相关的
        deviceId: "",
        deviceName: this.devAreaName,
        deviceType: this.checkDevType,
        factoryId: this.devAreaManu,
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        // parentCodes: this.areaDevGroupCode,  //区域相关的，父级code
        // status: ''
        status: this.cameraStatus,
        isMap: this.isMap ? "1" : "",
      };
      this.getDevPra = params;
      this.getDevList();
    },
    // 编辑框保存按钮
    editDlgPre() {
      let data = {};
      data = this.$refs.editDev.devInData;
      this.$refs.editDev.validateForm().then((valid) => {
        // console.log(data);
        if (valid) {
          let params = {
            // buildingName:"",//建筑物名称
            buildingCode: data.buildingCode, //建筑物id
            abscissa: data.isIndoor == 1 ? data.abscissa : null, //横坐标
            ordinate: data.isIndoor == 1 ? data.ordinate : null, //纵坐标
            width: data.isIndoor == 1 ? data.width : null,
            height: data.isIndoor == 1 ? data.height : null,
            deviceId: data.deviceId, //设备id
            deviceName: data.deviceName, //设备名称
            latitude: data.isIndoor == 0 ? data.latitude : null,
            longitude: data.isIndoor == 0 ? data.longitude : null,
            isIndoor: data.isIndoor, //0 室外，1室内
            deviceDescription: data.deviceDescription, //设备描述
            area: data.areaCode, //区域编码
            buildingId: data.isIndoor == 1 ? data.buildingId : "", //楼栋id
            buildName: data.isIndoor == 1 ? data.buildName : "", //楼栋名称
            floorId: data.isIndoor == 1 ? data.floorId : "", //楼层id
            floorName: data.isIndoor == 1 ? data.floorName : "", //楼层名称

            resolutionWide: data.resolutionWide, //像素宽
            resolutionHigh: data.resolutionHigh, //像素高

            ip: data.ip,
            port: data.port,
            userName: data.userName,
            password: data.password,

            altitude: data.altitude,
            // trafficType: data.trafficType,//通行方式
          };
          // console.log(params, "---params-----");
          this.editLoading = true;
          this.$fetch(api.deviceMan.updateDeviceInfoById, params).then((res) => {
            this.editLoading = false;
            if (res.success === true) {
              this.$message.success(res.msgContent || "操作成功");
              this.$refs.editDev.devInData.resolutionWide = "";
              this.$refs.editDev.devInData.resolutionHigh = "";
              this.editDevDialog = false;
              this.getDevList();
            } else if (res.success === false) {
              this.$message.error(res.msgContent);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 编辑框取消按钮
    editDlgCan() {
      this.$refs.editDev.devInData.resolutionWide = "";
      this.$refs.editDev.devInData.resolutionHigh = "";
      this.editDevDialog = false;
    },
    // 分页事件
    selectPage(val) {
      this.$refs.devTab.selectClear();
      this.page.currentPage = val;
      this.getDevPra.page = val;
      if (!this.clickSearch || !this.isArea) {
        this.getDevPra.isArea = this.isArea = "";
      }
      this.getDevPra.deviceType = this.checkDevType;
      this.getDevList();
    },
    changeSize(val) {
      this.getDevPra.pageSize = val;
      this.getDevPra.page = 1;
      this.getDevPra.deviceType = this.checkDevType;
      if (!this.clickSearch || !this.isArea) {
        this.getDevPra.isArea = this.isArea = "";
      }
      this.page.pageSize = val;
      this.page.currentPage = 1;
      this.getDevList();
    },
    // 切换左侧选项卡
    handleChange(column) {
      this.type = column;
      // 切换选项卡重置所有搜索条件
      this.devAreaName = "";
      this.devAreaManu = "";
      this.devTyName = "";
      this.devTyId = "";
      this.isArea = "";
      this.isDeviceWorkGroup = "";
      this.cameraStatus = "";
      this.cameraFeature = "";
      this.checked = false;
      this.checkedDevice = false;
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.deviceTreeShow = false;
      if (this.type.prop === "tab1") {
        this.activeState = Number;
        // 切换头部按钮
        this.accType = true;
        this.accReg = false;
        // 切换表格样式
        this.calMetOption = deviceTableOption(true, true);
        // 切换头部搜索条件
        this.devTypeSer = true;
        this.devAreaSer = false;
        // 清空请求条件，请求全量数据
        // this.initGet();
      } else if (this.type.prop === "tab2") {
        this.accType = false;
        this.accReg = true;
        this.calMetOption = deviceTableOption(false, false);
        this.devTypeSer = false;
        this.devAreaSer = true;
        // this.initGet();
      }
      this.$nextTick(() => {
        this.$refs.devTab.reset();
      });
    },
    setCheckDevType() {
      // console.log(this.$route.query);
      if (this.$route.query.device.deviceTypeId) {
        this.checkDevType = this.$route.query.device.deviceTypeId;
        Cache.put("deviceTypeId", this.$route.query.device.deviceTypeId);
        this.paramsType = this.$route.query.device.deviceType;
        Cache.put("deviceType", this.$route.query.device.deviceType);
      } else {
        // 缓存参数 防止页面属性数据丢失
        this.checkDevType = Cache.get("deviceTypeId");
        this.paramsType = Cache.get("deviceType");
      }
    },
    // 初始化查询条件，查询全量数据；
    initGet() {
      this.setCheckDevType();
      let params = {
        area: "", //区域相关的
        deviceId: "",
        deviceName: "",
        deviceType: this.checkDevType,
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        parentCodes: "", //区域相关的，父级code
        // status: ''
        status: this.cameraStatus,
        deviceWorkGroupCode:
          this.deviceWorkGroupCode !== "" ? this.deviceWorkGroupCode : "",
        isMap: this.isMap ? "1" : "",
      };
      // console.log('--this.deviceWorkGroupCode-----', this.deviceWorkGroupCode);
      this.getDevPra = params;
      this.getDevList();
    },
    // 勾选事件
    selectionChange(selections) {
      if (selections.length < this.page.pageSize && selections.length > 0) {
        setTimeout(() => {
          $(".el-table__fixed-header-wrapper label.el-checkbox>span").attr(
            "class",
            "el-checkbox__input is-indeterminate"
          );
        }, 200);
      }
      this.selDev = [];
      this.selThirdDev = [];
      this.selectedDevs = selections;
      selections.map((item) => {
        this.selDev.push(item.deviceId);
        this.selThirdDev.push(item.thirdDeviceId);
      });
    },
    retBtn() {
      // this.$router.go(-1);
      this.$router.push("/cameralist/devicelist");
    },
    getDeviceWrokGroupCode(code) {
      this.deviceWorkGroupCode = code;
      this.initGet();
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.node-label {
  // display: inline-block;
  width: 300px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.ellipsis {
  width: 225px;
}
.vcnDeviceList {
  width: 100%;
  height: 100%;
  position: relative;
  .left_title {
    border-left: 4px solid #407aee;
    padding-left: 8px;
    margin: 16px;
  }
  .device-tab {
    display: flex;
    margin: 0 16px 0px 16px;
    .tab {
      // color: #9aa6c1;
      flex: 1;
      text-align: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #707070;
      &:hover {
        // color: #fff;
        cursor: pointer;
      }
    }
    .active {
      // color: #fff;
      border-color: #407aee;
    }
  }
  .device-search {
    display: flex;
    margin: 15px 16px;
    height: 28px;
    .el-input {
      width: 100%;
    }
  }
  .devTyList {
    padding: 3px 10px;
    margin: 5px 10px;
    cursor: pointer;
  }
  .devTyListCheck {
    @include set_theme_color(background-color, page-bg-color);
  }
  .left-type_area {
    height: calc(100% - 100px);
    position: relative;
    flex: 1;
    overflow: hidden;
    @include set_theme_color(background-color, left-menu-bg-color);
  }
  .el-dialog__footer {
    // padding: 20px;
    // padding-top: 10px;
    text-align: right;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .upload-demo {
    margin: 0 10px;
  }

  .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2),
  .el-tabs--bottom .el-tabs__item.is-top:nth-child(2),
  .el-tabs--top .el-tabs__item.is-bottom:nth-child(2),
  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 10px;
  }
}
.el-select {
  width: 100%;
}
.dialog-tree {
}
.dialog-bar {
  height: 400px;
  padding-bottom: 16px;
  @include set_theme_color(background-color, left-menu-bg-color);
}
</style>
